<template lang="pug">
    v-dialog(v-if="dialog && loading" )
        v-card
            v-layout
                v-flex.xs12.loader-container
                    v-progress-circular( indeterminate color="primary" )
                    span.body-2.ml-3 Cargando datos...
    div(v-else-if="loading")
        v-card
            v-layout
                v-flex.xs12.loader-container
                    v-progress-circular( indeterminate color="primary" )
                    span.body-2.ml-3 Cargando datos...
</template>

<script>
export default {
    name: 'loading-dialog',
    props: {
        /**
         * @description Controls component's visibility
         */
        loading: {
            type: Boolean,
            default: () => false
        },
        /**
         * @description
         */
        dialog: {
            type: Boolean,
            default: () => false
        },
    },
    data: function(){
        return {}
    },
    computed: {},
    methods: {},
    watch: {},
    components: {},
    mixins: [],
    filters: {},
    // Lifecycle Methods
    //
    // beforeCreate: function(){...},
    // created: function(){...},
    // beforeMount: function(){...},
    // mounted: function(){...},
    // beforeUpdate: function(){...},
    // updated: function(){...},
    // beforeDestroy: function(){...},
    // destroyed: function(){...},
    //
    // End Lifecycle Methods
}
</script>

<style lang="scss" scoped>
.loader-container{
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    min-height: 60px;
}    
</style>